import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconDeviceGamepad2 } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface VideoGameListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const VideoGameListItem: React.FC<VideoGameListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconDeviceGamepad2}
    typeLabel="Video Game"
    testId="video-game-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.PLAY }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default VideoGameListItem
